const initialState = {
  DashData: null,
  UserPartnershipData: null,
};

const DashboardReducer = (state = initialState, { type, payload }) => {
  switch (type) {
    case "DASH_DATA":
      return {
        ...state,
        DashData: payload.data,
      };
    case "USER_PARTNER_DATA":
      return {
        ...state,
        UserPartnershipData: payload.data,
      };
    default:
      return state;
  }
};

export default DashboardReducer;
